module.exports = __webpack_public_path__ + "img/joinDotStraight.9e313f6b.svg";